import React, { useState, useEffect, useRef } from 'react';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Layout from 'antd/lib/layout';
import { Link, useHistory } from 'react-router-dom';
import { login } from 'parity-network-requests';
import { config } from '../../config';
import { ParityFooter } from '../ParityFooter';

import lightVars from '../../light.json';
import darkVars from '../../dark.json';
import './Login.less';

// ICONS
import lightModeIcon from '../../icons/darkmode-off.svg';
import darkModeIcon from '../../icons/darkmode-on.svg';

// IMAGES
import logo from '../../images/logo.png';
import darkModeLogo from '../../images/logo-light.png';

const { REACT_APP_BUILD_ENV } = config;

const headerStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
};

const contentStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  height: '60rem',
};

async function submitLogin(email, password) {
  const response = await login(REACT_APP_BUILD_ENV, email, password);
  return response;
}

export function Login(props) {
  const { location } = props;
  const nextUrl = location.state ? location.state.from : '/';
  const emailInputRef = useRef(null);

  const { Header, Content, Footer } = Layout;

  const [theme, setTheme] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();
  const [error, setError] = useState('');

  useEffect(() => {
    const getCurrentTheme = () => {
      const currentTheme = localStorage.getItem('theme-name');

      if (currentTheme === 'light') {
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme(currentTheme);
      } else if (currentTheme === 'dark') {
        localStorage.setItem('app-theme', JSON.stringify(darkVars));
        window.less.modifyVars(darkVars);
        setTheme(currentTheme);
      } else {
        localStorage.setItem('theme-name', 'light');
        localStorage.setItem('app-theme', JSON.stringify(lightVars));
        window.less.modifyVars(lightVars);
        setTheme('light');
      }
    };

    getCurrentTheme();
    emailInputRef.current.focus();
  }, []);

  const changeTheme = () => {
    let vars = {};
    let newTheme = '';

    if (theme === 'light') {
      vars = darkVars;
      newTheme = 'dark';
    } else {
      vars = lightVars;
      newTheme = 'light';
    }

    localStorage.setItem('app-theme', JSON.stringify(vars));
    localStorage.setItem('theme-name', newTheme);
    window.less.modifyVars(vars);
    setTheme(newTheme);
  };

  return (
    <Layout>
      <Header className={`app-header-${theme}`} style={headerStyle}>
        <div className="login-header__logo-container">
          <a href="/">
            {theme === 'light' ? (
              <img className="app-header__parity-logo" src={logo} alt="Parity Logo" />
            ) : (
              <img className="app-header__parity-logo" src={darkModeLogo} alt="Parity Logo" />
            )}
          </a>
        </div>
        <div className="app-header__buttons">
          <span role="presentation" onClick={changeTheme}>
            {theme === 'light' ? (
              <img className="app-header__dark-mode" src={lightModeIcon} alt="Light Mode" />
            ) : (
              <img className="app-header__dark-mode" src={darkModeIcon} alt="Dark Mode" />
            )}
          </span>
        </div>
      </Header>
      <Content style={contentStyle}>
        <div className={`login login-${theme}`}>
          <div className="login-spacer" />
          <div className="login-content">
            <div className="login-card">
              <div className="login-card__content">
                <div className="login-card__title">Welcome to Pi</div>
                <div className="login-card__description">
                  The place to monitor your building and track your real-time energy savings
                </div>
                {error && <div className="login__error">{error}</div>}
                <Form
                  layout="vertical"
                  className={`login-card__form app-form-${theme}`}
                  onFinish={async () => {
                    const loginResult = await submitLogin(email, password);

                    if (typeof loginResult === 'string') {
                      setError(loginResult);
                    } else {
                      history.push(nextUrl);
                    }
                  }}
                >
                  <Form.Item
                    name="email"
                    label="E-mail"
                    className="login__input-wrapper"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter your email',
                      },
                    ]}
                    hasFeedback
                  >
                    <Input
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      size="large"
                      className="login__input"
                      ref={emailInputRef}
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    label="Password"
                    className="login__input-wrapper"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter your password',
                      },
                    ]}
                  >
                    <Input.Password
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      size="large"
                      className="login__input"
                    />
                  </Form.Item>
                  <div className="login__forgot-password-wrapper">
                    <Link to="/forgot-password" className="login__forgot-password">
                      Forgot your password?
                    </Link>
                  </div>
                  <div className="login__button-wrapper">
                    <Button block htmlType="submit" size="large" className="login__button">
                      <div className="login__button-text">Sign in</div>
                    </Button>
                  </div>
                </Form>
                <div className="login__signup-text">
                  <div>Don&apos;t have an account? </div>
                  <Link to="/signup" className="login__signup-text--blue">
                    Sign up
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Content>
      <Footer className="app__footer">
        <ParityFooter />
      </Footer>
    </Layout>
  );
}
